import axios from 'axios';
import { isTokenValid } from '../utils/authUtils';

const axiosInstance = axios.create({
  baseURL: 'https://trippin.icu/api',
  //baseURL: 'http://localhost:5002/api',
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken && isTokenValid(accessToken)) {
      console.log('Access token is valid. Adding to request headers.');
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    else {
      console.log('Access token is missing or invalid.');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (originalRequest.url.includes('/auth/refresh')) {
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshAxios = axios.create();
        const { data } = await refreshAxios.post(
          'https://trippin.icu/api/auth/refresh',
          //'http://localhost:5002/api/auth/refresh',
          {},
          { withCredentials: true }
        );

        localStorage.setItem('accessToken', data.accessToken);

        originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError);
        localStorage.removeItem('accessToken');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
